import { fetchMethod } from '../../../common/apiGate';
import { API_URL } from '../../../config';

const SETTINGS_API_URL = `${API_URL}/v2/settings`;

/**
 * Read the Google image pull settings from the API.
 *
 * @returns {Promise<any>} - Promise with the settings data.
 * @throws {Error} - If the API request fails
 */
export const getGoogleImagePull = async () => {
  return fetchMethod(
    `${SETTINGS_API_URL}/google-image-pull`,
    null,
    'get',
    true
  );
};

/**
 * Update the Google image pull settings via the API.
 *
 * @param {boolean} googleImagePull - The new value for the Google image pull setting.
 * @returns {Promise<any>} - Promise with the response data.
 * @throws {Error} - If the API request fails
 */
export const updateGoogleImagePull = async (googleImagePull) => {
  return fetchMethod(
    `${SETTINGS_API_URL}/google-image-pull`,
    { googleImagePull },
    'post',
    true
  );
};

export const getHistoryCaptureInterval = async () => {
  return fetchMethod(
    `${SETTINGS_API_URL}/history-capture-interval`,
    null,
    'get',
    true
  );
};

export const updateHistoryCaptureInterval = async (
  historyCaptureIntervalMinutes
) => {
  return fetchMethod(
    `${SETTINGS_API_URL}/history-capture-interval`,
    { historyCaptureIntervalMinutes },
    'put',
    true
  );
};
